import { useEffect, useState } from "react";

/** Whether the viewport is wide enough for the long table; live as it resizes. */
export function useWide(query = "(min-width: 760px)") {
  const [wide, setWide] = useState(() => window.matchMedia(query).matches);
  useEffect(() => {
    const media = window.matchMedia(query);
    const update = () => setWide(media.matches);
    update();
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, [query]);
  return wide;
}
